import React from "react";
import PropTypes from "prop-types";
import { Link, Navigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Form } from "components/Form";
import Button from "components/Button";
import { ReactComponent as LoadingIcon } from "images/icons/loading.svg";

function FormChildren({
  children,
  title,
  submitText,
  cancelUrl,
  cancelText,
  success,
  loading,
  onSuccess,
  navigateToOnSuccess,
}) {
  if (success) {
    if (onSuccess) {
      onSuccess();
    }
    if (navigateToOnSuccess) {
      return <Navigate to={navigateToOnSuccess} />;
    }
  }

  return (
    <>
      <h1 className="text-main-color w-full text-start md:text-center font-semibold md:text-2xl text-sm">
        {title}
      </h1>
      {children}
      <div className="text-center">
        <Button
          type="submit"
          variant="contained"
          color="blue"
          disabled={loading}
          label={submitText ?? "Valider"}
          icon={loading ? <LoadingIcon /> : ""}
          className="py-3 mx-auto px-8 bg-main-color text-white rounded-lg font-bold"
        />
        {cancelUrl && (
          <div className="mt-3">
            <Link
              to={cancelUrl}
              className="text-xs underline underline-offset-2 hover:no-underline text-light-color"
            >
              {cancelText}
            </Link>
          </div>
        )}
      </div>
    </>
  );
}

const commonPropTypes = {
  children: PropTypes.any,
  title: PropTypes.string.isRequired,
  submitText: PropTypes.string,
  cancelUrl: PropTypes.string,
  cancelText: PropTypes.string,
  success: PropTypes.bool,
  loading: PropTypes.bool,
  onSuccess: PropTypes.func,
  navigateToOnSuccess: PropTypes.string,
  initialError: PropTypes.string,
};

const commonDefaultProps = {
  children: null,
  submitText: null,
  cancelUrl: null,
  cancelText: null,
  onSuccess: null,
  navigateToOnSuccess: null,
};

FormChildren.propTypes = {
  ...commonPropTypes,
};

FormChildren.defaultProps = {
  ...commonDefaultProps,
};

export default function AuthForm({
  submit,
  cancelUrl,
  cancelText,
  title,
  children,
  loading,
  ...formProps
}) {
  const childrenProps = {
    children,
    cancelUrl,
    title,
    cancelText,
    loading,
  };
  return (
    <AuthLayout>
      <Form {...formProps}>
        <form
          onSubmit={submit}
          className="flex flex-col items-stretch  justify-center bg-white z-10 gap-8 py-8 flex-grow max-w-[464px] md:m-auto"
        >
          <FormChildren {...childrenProps} />
        </form>
      </Form>
    </AuthLayout>
  );
}

AuthForm.propTypes = {
  ...commonPropTypes,
  initialError: PropTypes.string,
  submit: PropTypes.func.isRequired,
};

AuthForm.defaultProps = {
  ...commonDefaultProps,
};
